import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabMenuComponent } from './tab-menu/tab-menu.component';

@NgModule({
  declarations: [TabMenuComponent],
  imports: [
    CommonModule,
  ],
  exports: [TabMenuComponent],
})
export class TabMenuModule {
}
